// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__0KKtV","changeDevice":"style_changeDevice__z3kC8","title":"style_title__DXW41","selectedDevice":"style_selectedDevice__gFhC3","label":"style_label__TI97W"};